import { render, staticRenderFns } from "./VeeLabelEditItem.vue?vue&type=template&id=33c4c6a1&"
import script from "./VeeLabelEditItem.vue?vue&type=script&lang=js&"
export * from "./VeeLabelEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports